<section class="wrapper task-wrapper loading-wrapper" *ngIf="isLoading">
  <div class="loading-indicator">
    <i class="fa fa-circle-o-notch fa-spin fa-4x"></i>
  </div>
  <div class="loading-text" *ngIf="loadingText">{{loadingText}}</div>
</section>
<section class="wrapper task-wrapper" *ngIf="!isLoading">
  <div class="task-progress-wrapper">
    <app-connection-progress [stage]="stage"></app-connection-progress>
  </div>
  <div class="task-form-wrapper">
    <app-connection-step-a
      class="step-a"
      *ngIf="stage == 1"
      (login)="onLogin($event)"
      [authType]="loginData.authType"
      [user]="loginData.user"
      [applicationId]="loginData.applicationId"
      [clientId]="loginData.clientId"
      [tenantId]="loginData.tenantId"
      [editMode]="isEditMode"
      [hasExistingPassword]="editHasPassword"
      [hasExistingClientSecret]="editHasClientSecret"
      [error]="errorStep1"
    ></app-connection-step-a>
    <app-connection-step-b
      class="step-b"
      *ngIf="stage == 2"
      (register)="onRegister($event)"
      [error]="errorStep2"
    ></app-connection-step-b>
    <app-connection-step-c
      class="step-c"
      *ngIf="stage == 3"
      (verify)="onVerify()"
      [error]="errorStep3"
      [applicationId]="applicationId"
      [applicationName]="applicationName"
    ></app-connection-step-c>
    <app-connection-step-d
      class="step-d"
      *ngIf="stage == 4"
      [testResult]="testResult"
      [connectionInfo]="connectionInfo"
      (testConnection)="onTestConnection()"
      (editConnection)="onEditConnection()"
    ></app-connection-step-d>
  </div>
</section>
